export const deviceTypeAction = {
  setDeviceTypes: (state, action) => {
    state.deviceTypes = action.payload;
  },
};
